<template>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.8 1C13.8 0.558172 13.4418 0.2 13 0.2C12.5582 0.2 12.2 0.558172 12.2 1L13.8 1ZM12.4343 19.5657C12.7467 19.8781 13.2533 19.8781 13.5657 19.5657L18.6569 14.4745C18.9693 14.1621 18.9693 13.6556 18.6569 13.3431C18.3444 13.0307 17.8379 13.0307 17.5255 13.3431L13 17.8686L8.47452 13.3431C8.1621 13.0307 7.65557 13.0307 7.34315 13.3431C7.03073 13.6556 7.03073 14.1621 7.34315 14.4745L12.4343 19.5657ZM12.2 1L12.2 19L13.8 19L13.8 1L12.2 1Z"
            fill="#545E61"
        />
        <path
            d="M25 25H1"
            stroke="#545E61"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
